import { InferGetServerSidePropsType } from 'next';

import config from 'config';
import withPageLayout from 'core/hocs/withPageLayout';
import { shopsWithArticles } from 'consts/shopPages';
import { pageRequestConfig, GetPageResults, GetPageVariables } from 'graphql/queries/GetPageData.query';
import {
  articleCategoriesWithArticlesRequestConfig,
  GetArticleCategoriesWithArticlesResult,
  GetArticleCategoriesWithArticlesVariables,
} from 'graphql/queries/GetArticlesCategoriesWithArticles.query';
import { GetPageLayoutResult, serverRequests as pageLayoutServerRequests } from '@layouts/PageLayout/PageLayout.utils';
import ArticlesCategories from '@pages/ArticlesCategories';
import getCommonServerSideProps from 'utils/getCommonServerSideProps';
import { RequestConfig } from 'utils/combineRequest';

const { routes } = config;

const serverRequests: RequestConfig[] = [
  ...pageLayoutServerRequests,
  pageRequestConfig,
  articleCategoriesWithArticlesRequestConfig,
];

export const getServerSideProps = getCommonServerSideProps<
  GetPageLayoutResult & GetPageResults & GetArticleCategoriesWithArticlesResult,
  GetPageVariables & GetArticleCategoriesWithArticlesVariables
>(
  routes.articles.href,
  serverRequests,
  {
    pages: [routes.articles.href],
    articleCategoriesSlug: { _is_null: false },
    articleCategoriesLimit: 5,
  },
  (r) => r,
  shopsWithArticles
);

const ArticlesCategoriesPage = ({
  articleCategories,
}: InferGetServerSidePropsType<typeof getServerSideProps>): JSX.Element => (
  <ArticlesCategories articleCategories={articleCategories} />
);

export default withPageLayout(ArticlesCategoriesPage, {
  showBreadcrumb: true,
  breadcrumbVariant: 'articles',
  breadcrumbLinkVariant: 'real',
});
